import BaseApi from '@core/api/model';

export class TermsApi extends BaseApi {
    static resource = 'terms';
}

export default TermsApi;
